import { render, staticRenderFns } from "./KapuresTotals.vue?vue&type=template&id=6d3895bc&"
import script from "./KapuresTotals.vue?vue&type=script&lang=js&"
export * from "./KapuresTotals.vue?vue&type=script&lang=js&"
import style0 from "./KapuresTotals.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports